import React, { useContext, useMemo, useState } from 'react'

// Material ui - lab

// Material.ui
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar'

// moment
import moment from 'moment'
import API from '../../../services/api'
import { ReportContext } from '../../../providers/report'
import 'moment/locale/pt-br'

import { Table } from '../../ui/Table'


import {
  formatMoney,
  formatName,
  getDepartmentName,
  formatDateShort } from "../../../services/functions"
import { Pagination } from '../../ui/Pagination'
import { useMerchant } from '../../../store/global/useMerchant'
import { DashboardSummary } from './DashboardSummary'
import { AgendaReportFilter } from './AgendaReportFilter'
import { UserRoundCog } from 'lucide-react'
import { CustomerDetailsController } from '../../../services/controllers/customer'

moment.locale('pt-br')

/** Colunas ordenaveis -> campo da linha. As demais ficam como texto simples. */
const SORTABLE_COLUMN_KEYS = {
  Data: "date",
  Profissional: "employee",
  Tutor: "tutor",
  Pet: "pet",
  "Serviço": "serviceName",
  Categoria: "serviceCategory",
  Status: "orderStatus",
  "V. Original": "servicePrice",
  "V. Cobrado": "serviceChargedPrice",
}

const CAMPOS_NUMERICOS = ["servicePrice", "serviceChargedPrice"]



function compara(a, b, campo) {
  const x = a?.[campo]
  const y = b?.[campo]

  if (x === y) return 0
  if (x === null || x === undefined || x === "") return 1
  if (y === null || y === undefined || y === "") return -1

  if (CAMPOS_NUMERICOS.includes(campo)) {
    return Number(x) - Number(y)
  }

  if (campo === "date") {
    return moment(x).valueOf() - moment(y).valueOf()
  }

  return String(x).localeCompare(String(y), "pt-BR", { sensitivity: "base" })
}

// CSS
function RelatorioAgenda({ primeiroDia, date }) {
  const {
    deadLine,
    firstData,
    setFirstData,
    setLastData,
    setDepartment,
    getReports,
    infoRepoart,
    lastData,
    department,
    getDownloads,
    profissional,
    setEmployeeId,
    setCpf,
    setStatus,
    status,
    employeeId,
    cpf,
    paginationAgenda
  } = useContext(ReportContext)
  const CCustomerDetails = CustomerDetailsController();
  const merchant = useMerchant((st) => st.data.merchant)

  // A API desta aba ainda nao aceita ordenacao, entao ordenamos a pagina
  // carregada. Quando o back passar a ordenar, isto vira uma chamada como nos
  // outros relatorios.
  const [sort, setSort] = useState({ sortBy: null, sortOrder: "asc" })
  const [kpiAtivo, setKpiAtivo] = useState(null)

  // o KPI filtra o relatorio inteiro pelo servidor: antes ele recortava so a
  // pagina carregada, entao o numero do KPI (67) nao batia com as linhas (1)
  const selecionaKpi = (kpi) => {
    setKpiAtivo(kpi)
    getReports(0, kpi)
  }

  const linhasOrdenadas = useMemo(() => {
    const linhas = Array.isArray(infoRepoart) ? infoRepoart : []
    if (!sort.sortBy) return linhas

    const fator = sort.sortOrder === "asc" ? 1 : -1
    return [...linhas].sort((a, b) => compara(a, b, sort.sortBy) * fator)
  }, [infoRepoart, sort])

  const handleSortColumn = (sortBy) => {
    setSort((atual) => ({
      sortBy,
      sortOrder: atual.sortBy === sortBy && atual.sortOrder === "asc" ? "desc" : "asc",
    }))
  }

  const [open, setOpen] = useState(false)
  const [messageExport, setMessageExport] = useState(null)
  const [disabledBtn, setDisabledBtn] = useState(false)

  const handleClose = () => {
    setOpen(false)
    setDisabledBtn(false)
  }

  async function reportsExport() {
    try {
      const {
        data: { message },
      } = await API.post('reports/export', {
        filters: {
          dateFrom: firstData
            ? moment(firstData).format('YYYY-MM-DD')
            : primeiroDia,
          dateTo: lastData || moment(date).format('YYYY-MM-DD'),
          status: status === 'TODOS' ? null : status,
          cpf,
          employee: employeeId === 'TODOS' ? null : employeeId,
          department,
        },
        type: {
          name: 'appointments',
          format: 'xlxs',
        },
      })
      setMessageExport(message)
      if (message) {
        setOpen(true)
        getDownloads()
      }
    } catch (err) {
      console.log('Erro:', err)
    }
  }


  const profissionalByDepartment = !!profissional && profissional.filter((item) => {
    if (department === "Clínica Veterinária") {
      return ["Veterinário"].includes(item.group)
    }

    if (department === "Banho e tosa") {
      return ["Tosador 1", "Banhista", "Tosador 2", "Groomer"].includes(item.group)
    }
  })

  return (
    <>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="success">
            <AlertTitle>Success</AlertTitle>
            {messageExport}
          </Alert>
        </Stack>
      </Snackbar>

      <div className='flex w-full flex-col gap-5 pt-5'>
      {primeiroDia && (
        <AgendaReportFilter
          firstData={firstData}
          lastData={lastData}
          deadLine={deadLine}
          department={department}
          employeeId={employeeId}
          status={status}
          cpf={cpf}
          professionals={profissionalByDepartment}
          hasVeterinary={merchant?.departments?.includes("Clínica Veterinária")}
          showPaid={!merchant?.hasTokenVarejo}
          exporting={disabledBtn}
          onChange={{
            firstData: setFirstData,
            lastData: setLastData,
            department: setDepartment,
            employeeId: setEmployeeId,
            status: setStatus,
            cpf: setCpf,
          }}
          onFilter={() => {
            setKpiAtivo(null)
            getReports(0, null)
          }}
          onExport={reportsExport}
        />
      )}

      <DashboardSummary kpiAtivo={kpiAtivo} onSelectKpi={selecionaKpi} />

      <Table.Root name='table-schedules-report'>
        <Table.Header
          columns={[
            "Data:100px",
            "Profissional:minmax(100px, 170px)",
            "Tutor:minmax(100px, 190px)",
            "Pet:minmax(100px, 150px)",
            "Serviço:minmax(100px, 190px)",
            "Categoria:minmax(0px, 160px)",
            "Status:minmax(0px, 170px)",
            "V. Original:minmax(0px, 110px)",
            "V. Cobrado:minmax(0px, 110px)",
            "Pacote?:minmax(0px, 80px)",
          ]}
          sortableConfig={{
            sortBy: sort.sortBy,
            sortOrder: sort.sortOrder,
            onSort: handleSortColumn,
            columnKeys: SORTABLE_COLUMN_KEYS,
          }}
        />
        <Table.Content>
          {linhasOrdenadas.map((row, index) => (
            <Table.Line key={`${row.order || row.date}-${index}`}>
              <Table.Item>{formatDateShort(row.date)}</Table.Item>
              <Table.Item>{formatName(row.employee || '-')}</Table.Item>
              <Table.Item>
                <button type="button" className="font-medium flex gap-1 items-center border-b border-transparent hover:border-current" onClick={() => CCustomerDetails.open(row.tutorId)}>
                  <UserRoundCog aria-hidden="true" size={16} />
                  {formatName(row.tutor || '-')}
                </button>
              </Table.Item>
              <Table.Item>{formatName(row.pet || '-')}</Table.Item>
              <Table.Item>{formatName(row.serviceName || '-')}</Table.Item>
              <Table.Item>{formatName(row.serviceCategory || '-')}</Table.Item>
              <Table.Item>{formatName(row.orderStatus || '-')}</Table.Item>
              <Table.Item>R$ {formatMoney(row.servicePrice || '0')}</Table.Item>
              <Table.Item>R$ {formatMoney(row.serviceChargedPrice || '0')}</Table.Item>
              <Table.Item>{formatName(row.packagePrice || '-')}</Table.Item>
            </Table.Line>
          ))}
        </Table.Content>
        {!!paginationAgenda &&
          <Pagination.Root
            name='pagination-schedules-report'
            totalPages={paginationAgenda.totalPages - 1}
            currentPage={paginationAgenda.currentPage}
            onChange={(pagina) => getReports(pagina, kpiAtivo)}
          >
            <Pagination.Back />
            <Pagination.Pages />
            <Pagination.Forward />
          </Pagination.Root>
        }
      </Table.Root>
      </div>
    </>
  )
}

export default RelatorioAgenda
